import React, { useContext } from "react";
import "./Common_Multiple_Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Context } from "../../../utils/context";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";

const Common_Multiple_Banner = ({ imgSrc, breakpoints, ...props }) => {
  const { imageUrl } = useContext(Context);

  return (
    <section className="Common_Multiple_Banner">
      <div className="">
        <div className="main_content_div">
          <Swiper
            {...props}
            spaceBetween={10}
            // slidesPerView={7}
            breakpoints={breakpoints}
            autoplay={{ delay: 3000 }}
            modules={[Autoplay]}
          >
            {imgSrc?.map((item) => {
              return (
                <SwiperSlide>
                  <div className="slider_banner_div">
                    <img src={imageUrl + item} className="slider_img" />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Common_Multiple_Banner;
